import "@app/App.css";
import { Notification } from "@comps/ui/notification";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import { TW_ObjectHeaderButtonTitle, TW_ObjectModelViewHeaderButton, TW_ObjectModelViewHeaderIcon } from "@utils/twClasses";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataStore, useModelStore, useUserStore } from "src/store";
import PivotEditor from "./PivotEditor";
import { ReactComponent as PivotSVG } from "@img/pivot.svg";
import { FullRightAccess, hasGlobalRightAccess, ViewRightType } from "@dto/Users";
import { getFieldByPathKeys } from "@utils/model";

function PivotButton() {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const selectedView = useModelStore((state) => state.selectedView);
  const selectedObjectInfos = useModelStore((state) => state.selectedObjectInfos);
  const user = useUserStore((state) => state.user);
  const userRole = useModelStore((state) => state.userRole);
  const { t } = useTranslation();
  const rowActionsEnabled = useDataStore(state => state.rowActionsEnabled);

  const fields = selectedObjectInfos?.fields || null;
  const fieldByKeys = useModelStore(state => state.fieldByKeys);
  const relationByKeys = useModelStore(state => state.relationByKeys);
  const fieldByPathKeys = getFieldByPathKeys(selectedObjectInfos, selectedObjectInfos?.fields || [], relationByKeys, fieldByKeys);
  const pivot = selectedView?.pivot;
  if (pivot?.pivotPathKey && !fieldByPathKeys.get(pivot.pivotPathKey)) {
    pivot.pivotPathKey = null;
    pivot.valuePathKeys = null;
  }
  if (pivot?.valuePathKeys && pivot.valuePathKeys.length > 0) {
    pivot.valuePathKeys = pivot.valuePathKeys.filter(valuePathKey => fieldByPathKeys.get(valuePathKey) !== undefined);
    if (pivot.valuePathKeys.length === 0) {
      pivot.valuePathKeys = null;
      pivot.pivotPathKey = null;
    }
  }



  const hasPivot = pivot?.pivotPathKey && fieldByPathKeys.get(pivot.pivotPathKey);

  const hasFullAccess = selectedView?.ownerKey === user?._key || hasGlobalRightAccess(user, userRole, ViewRightType, FullRightAccess, selectedView?._key);
  const isDisabled = (!fields || fields.length === 0) || !rowActionsEnabled;
  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger disabled={isDisabled} className={TW_ObjectModelViewHeaderButton + (isDisabled ? " opacity-50 cursor-not-allowed" : " opacity-100 cursor-default")}>
        <div className="flex flex-row justify-start items-center relative">
          <PivotSVG className={TW_ObjectModelViewHeaderIcon} color="#999999" />
          {/* <LibraryBig className={TW_ObjectModelViewHeaderIcon} /> */}
          {hasPivot && <Notification number={null} />}
        </div>
        <span className={TW_ObjectHeaderButtonTitle}>{t('object.header.button.pivot.rows.title')}</span>
      </PopoverTrigger>
      <PopoverContent className="w-max p-2">
        <PivotEditor pivot={pivot || null} disabled={!hasFullAccess} onClose={() => setIsPopoverOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}

export default PivotButton;